import React from 'react';

const headerAnimations = `
  
  .app-button {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .app-button:hover {
    transform: scale(1.1);
    box-shadow: 0 7px 14px rgba(0,0,0,0.1);
  }
`;

function AppStoreButtons() {
	return (
		<>
			<style>{headerAnimations}</style>
			<a className="app-button" href="https://www.apple.com/app-store/" target="_blank" rel="noreferrer" title="App Store">
				<img src={require('../assets/images/appstore-logo.webp')} loading="lazy" alt="App Store" height="40" width={130} title="App Store" />
			</a>
			<a className="app-button" href="https://play.google.com/store/apps/details?id=com.laykagift.laykaApp&utm_source=website" target="_blank" rel="noreferrer" title="Play Store">
				<img src={require('../assets/images/playstore-logo.webp')} loading="lazy" alt="Play Store" height="40" width={130} title="Play Store" />
			</a>
		</>
	);
}

export default AppStoreButtons;
